import React from "react";
import "./Newarrival.css";

function Newarrival() {
  return (
    <div className="a1 ">
      <div className="aa1">
        <div className="a1a">
          <h3 className="fw-lighter text-danger ">NEW ARRIVALS</h3>
          <h3 className="text-danger">with resonable prices.</h3>
          <h6>QUICK DELIVERY</h6>
          <p className="text-muted">
            We are offering quickest delivery all over Pakistan.
          </p>
          <h6>FREE SHIPPING</h6>
          <p className="text-muted">All over pakistan</p>
          <h6>CASH ON DELIVERY</h6>
          <p className="text-muted">
            Casio Store providing possible ease to customers
          </p>
          <h6>BANK TRANSFER</h6>
          <p className="text-muted">
            Payment above 15000/- we accept bank transfer
          </p>
          <a class="fancy" href="#">
  <span class="top-key"></span>
  <span class="text">Buy Now</span>
  <span class="bottom-key-1"></span>
  <span class="bottom-key-2"></span>
</a>
        </div>
        <div className="a1b">
          <img
            className="aimg"
            src="https://icasiostore.pk/wp-content/uploads/2022/01/banner-edifice-580x380_c.webp"
            alt="j"
          />
        </div>
      </div>
    </div>
  );
}

export default Newarrival;

// import React from 'react'
// import './Newarrival.css'

// function Newarrival() {
//     return (

//         <div className="grid-container d-flex justify-content-center mt-5 gap-5 flex-wrap">

//             <div className="grid-item mb-3 mt-3">
//                 <h3 className='fw-lighter text-danger '>NEW ARRIVALS</h3>
//                 <h3 className='text-danger'>with resonable prices.</h3>
//                 <h6>QUICK DELIVERY</h6>
//                 <p className='text-muted'>We are offering quickest delivery all over Pakistan.</p>
//                 <h6>FREE SHIPPING</h6>
//                 <p className='text-muted'>All over pakistan</p>
//                 <h6>CASH ON DELIVERY</h6>
//                 <p className='text-muted'>Casio Store providing possible ease to customers</p>
//                 <h6>BANK TRANSFER</h6>
//                 <p className='text-muted'>Payment above 15000/- we accept bank transfer</p>
//                 <button type="button" class="btn btn-danger"><b>BUY NOW</b></button>

//             </div>
//             <div className="grid-item mb-3 mt-3 "><img className='newimg' src="https://icasiostore.pk/wp-content/uploads/2022/01/banner-edifice-580x380_c.webp" alt="j" />
//             </div>

//         </div>
//     )
// }

// export default Newarrival
